module.exports = __webpack_public_path__ + "static/media/03.4094536f.jpeg";